module.exports = __webpack_public_path__ + "img/history_btn.9e4619a5.png";